export function downloadBlobFile(
  blobData: Blob,
  fileName: string | undefined,
): void {
  const url = window.URL.createObjectURL(blobData);
  const link = document.createElement("a");
  link.href = url;
  if (typeof fileName === "string") {
    link.setAttribute("download", fileName);
  }
  document.body.appendChild(link);
  link.click();
  link.remove();
}
